<article class="university-container">
  <section class="university-logo-container">
    <figure class="icon-wrapper">
      <img src="images/aum-logo.png" alt="aum Logo" class="icon" />
    </figure>
  </section>
  <section class="university-name-container">
    <h1 class="name">
      {{
        this.isMobileScreen
          ? ""
          : this.isTabletScreen
          ? ("universityAcronym" | translate)
          : ("universityName" | translate)
      }}
    </h1>
  </section>
</article>
